<script setup>
import { computed } from 'vue';
import { getDateLocale } from 'shared/helpers/dateLocale';
import { calendarWeeks } from '../helpers/DatePickerHelper';
const localizedWeeks = computed(() => {
  const locale = getDateLocale();
  return locale.code === 'ru'
    ? calendarWeeks.map(day => ({
        ...day,
        label: locale.localize.day(day.id % 7, { width: 'short' }),
      }))
    : calendarWeeks;
});
</script>

<template>
  <div class="max-w-md mx-auto grid grid-cols-7 gap-2">
    <div
      v-for="day in localizedWeeks"
      :key="day.id"
      class="flex items-center justify-center font-medium text-sm w-9 h-7 py-1.5 px-2"
    >
      {{ day.label }}
    </div>
  </div>
</template>
